import React from 'react';

import { UlStyled } from './Ul.style';

export const Ul = ({ children, ...props }: { children: any }) => {
  return <UlStyled {...props}>{children}</UlStyled>;
};
